import type { PlanReviewActionParamSource } from 'partner360/lib/planReviewActionParams'

export enum CommitmentReminderAction {
  ReviewPlanAction = 'jbp-reminder-action-plan-review',
}

export interface ICommitmentReminder {
  Variant?: string
  Icon: string
  Color: string
  TitleKey: string
  TextKey: string
  TextLinks: string
  Link?: string
  Action?: CommitmentReminderAction
  Actions?: string
}

export enum CommitmentReminderActionTypeEnum {
  JBPPatPlan = 'jbp-pat-plan',
  JbpPatTnet = 'jbp-pat-tnet',
  JbpPatSob = 'jbp-pat-sob',
  JBPPatMif = 'jbp-pat-mif',
  JBPPatInitiative = 'jbp-pat-initiative',
  JBPPatKi = 'jbp-pat-ki',
  JBPPatAcknowledgment = 'jbp-pat-acknowledgment',
}

export interface ICommitmentReminderActionItem {
  ActionOrder: number
  ActionType: CommitmentReminderActionTypeEnum
  ActionTitle: string
  ActionParam?: PlanReviewActionParamSource
  ActionLink?: string
  ActionBlockedBy?: string
  ActionDescription?: string
  Category?: string
}
